import React, { useEffect, useRef, useState } from 'react';
import { IonRow, IonSelect, IonSelectOption, IonCol } from '@ionic/react';
import { useHistory, useParams } from 'react-router-dom';
import { connect } from 'react-redux';
import Dialog from '@material-ui/core/Dialog';
import './CasinoNew.scss';
import { RootState } from '../../../models/RootState';
import { GapGame } from '../../../models/dc/DcGame';
import {
  getCurrencyTypeFromToken,
  FatchLiveCasinoGames,
  setSearchGame,
  handleSearchGame,
} from '../../../store';
import TabPanel from '../../../components/TabPanel/TabPanel';
import ClearIcon from '@material-ui/icons/Clear';
import inplay from '../../../assets/images/common/icons/Polygon.svg';
import RightSideNav1 from '../../../views/CommissionRules/RightSideNav/RightSideNav1';
import CompetitionsMenu from '../../../components/ExchCompetitionsMenu/ExchCompetitionsMenu';
import casinobg from '../../../assets/images/common/casinobg.png';

type StoreProps = {
  loggedIn: boolean;
  loggedInUserStatus: any;
  liveCasinoGames: GapGame[];
  FatchLiveCasinoGames: (type: string) => void;
  setSearchGame: Function;
  searchGame: string;
  handleSearchGame: () => void;
};

const DcPageNew: React.FC<StoreProps> = (props) => {
  const {
    loggedIn,
    loggedInUserStatus,
    liveCasinoGames,
    FatchLiveCasinoGames,
    setSearchGame,
    searchGame,
    handleSearchGame,
  } = props;
  let eventListRef = useRef<HTMLInputElement>();
  const [modalOpen, setModalOpen] = useState<boolean>(false);
  const [openDialog, setOpenDialog] = useState<boolean>(false);
  const [infoDialog, setInfoDialog] = useState<boolean>(false);
  const [selectedEvolutionGame, setSelectedEvolutionGame] = useState(null);
  const [casinoGameCatTabValue, setCasinoGameCatTabValue] = useState<number>(0);
  const [filteredProvider, setFilteredProvider] = useState<string>('');
  const [searchQuery, setSearchQuery] = useState<string>();
  const [dropDownList, setDropDownList] = useState<GapGame[]>();
  const [showDropDown, setShowDropDown] = useState<boolean>(false);
  const [providerList, setProviderList] = useState<string[]>();
  let filterList = [
    { label: 'Live Casino', value: 0 },
    { label: 'Roulette', value: 1 },
    { label: 'Baccarat', value: 2 },
    { label: 'BlackJack', value: 3 },
    { label: 'Poker', value: 4 },
  ];
  const pathParams = useParams();
  const Selectedprovider = pathParams['provider'];
  const gameName = pathParams['gameName'];
  const tabArray = [
    'all',
    'roulette',
    'baccarat',
    'blackJack',
    'poker',
    'evolution',
    'Pragmatic Play Live',
    'Others',
  ];

  useEffect(() => {
    let index = tabArray.indexOf(gameName);
    if (index > -1) {
      setCasinoGameCatTabValue(index);
    } else {
      setCasinoGameCatTabValue(0);
    }
  }, [gameName]);

  useEffect(() => {
    const handler = (e: MouseEvent) => {
      if (
        eventListRef.current &&
        !eventListRef.current.contains(e.target as Node)
      ) {
        setShowDropDown(false);
      }
    };

    document.addEventListener("mousedown", handler);

    return () => {
      document.removeEventListener("mousedown", handler);
    };
  }, []);

  const handleChange = (value) => {
    setSearchQuery(value);
    let localdropdownlist = [];
    if (value) {
      liveCasinoGames.forEach((indGame) => {
        if (
          indGame.gameName.toLowerCase().includes(value.toLowerCase()) ||
          indGame.subProviderName.toLowerCase().includes(value.toLowerCase())
        ) {
          localdropdownlist.push(indGame);
        }
      });
    }
    if (localdropdownlist.length) setShowDropDown(true);
    else setShowDropDown(false);
    setDropDownList(localdropdownlist);
  };

  useEffect(() => {
    if (Selectedprovider) {
      setFilteredProvider(Selectedprovider);
    } else {
      setFilteredProvider('');
    }
  }, [Selectedprovider]);

  const history = useHistory();

  const liveCasinoGamesMap = {
    blackJack: 'Live Blackjack',
    baccarat: 'Live Baccarat',
    roulette: 'Live Roulette',
    poker: 'Live Poker',
    other: 'Others',
  };

  const setDialogShow = (show: boolean) => {
    setModalOpen(true);
  };

  useEffect(() => {
    FatchLiveCasinoGames('casino');
  }, [filteredProvider]);

  useEffect(() => {
    if (liveCasinoGames?.length > 0)
      setProviderList(
        liveCasinoGames
          .map((g) => g.subProviderName)
          .filter(function (elem, index, self) {
            return index === self.indexOf(elem);
          })
      );
  }, [liveCasinoGames]);

  const getGameUrl = async (
    gameId: string,
    gameName: string,
    gameCode: string,
    provider: string,
    subProvider: string
  ) => {
    if (loggedIn) {
      if (loggedInUserStatus === 0 || loggedInUserStatus === 3) {
        history.push(`/home`);
      }
      if (provider === 'Indian Casino') {
        history.push(`/casino/indian/${gameCode}`);
      } else {
        history.push(
          `/gap_casino/game/${gameName
            .toLowerCase()
            .replace(/\s+/g, '-')}-${btoa(gameId.toString())}-${btoa(
            gameCode
          )}-${btoa(provider)}-${btoa(subProvider)}`
        );
      }
    } else {
      setDialogShow(true);
    }
  };

  const handleGameClick = async (
    gameId: string,
    gameName: string,
    gameCode: string,
    subProvider: string,
    provider?: string
  ) => {
    if (
      getCurrencyTypeFromToken() === 0 &&
      (subProvider.toLowerCase() === 'evolution gaming'||subProvider.toLowerCase() === 'spribe')
    ) {
      setSelectedEvolutionGame({
        gameId,
        gameName,
        gameCode,
        provider,
        subProvider,
      });
      setInfoDialog(true);
      return;
    }
    getGameUrl(gameId, gameName, gameCode, provider, subProvider);
  };

  let baccaratList = liveCasinoGames.filter(
    (g) =>
      g.category.toLowerCase().includes('baccarat') ||
      g.gameName.toLowerCase().includes('baccarat')
  );

  let rouletteList = liveCasinoGames.filter(
    (g) =>
      g.category.toLowerCase().includes('roulette') ||
      g.gameName.toLowerCase().includes('roulette')
  );

  let pokerList = liveCasinoGames.filter(
    (g) =>
      g.category.toLowerCase().includes('poker') ||
      g.gameName.toLowerCase().includes('poker')
  );

  let otherList = liveCasinoGames.filter(
    (g) =>
      g.category === liveCasinoGamesMap.other ||
      ['Onetouch Live', 'Asia Gaming'].includes(g.subProviderName)
  );

  let blackjackList = liveCasinoGames.filter(
    (g) => g.category === liveCasinoGamesMap.blackJack
  );

  let evolutionList = liveCasinoGames.filter(
    (g) => g.subProviderName === 'Evolution Gaming'
  );
  let superspadeList = liveCasinoGames.filter(
    (g) => g.subProviderName === 'Pragmatic Play Live'
  );
  let pragmaticList = liveCasinoGames.filter(
    (g) => g.subProviderName === 'Pragmatic Play Live'
  );
  let betGamesList = liveCasinoGames.filter(
    (g) => g.subProviderName === 'BetGames.TV'
  );
  let virtualList = liveCasinoGames.filter(
    (g) => g.category === 'Virtual Sports'
  );

  let allList = liveCasinoGames.filter((g) => {
    return g;
  });

  const aeSexy = liveCasinoGames.filter(
    (g) => g.subProviderName === 'AE SEXYBCRT'
  );
  const superNowaGame = liveCasinoGames.filter(
    (g) => g.subProviderName.toLowerCase() === 'supernowa'
  );

  useEffect(() => {
    document.getElementsByClassName('router-ctn')[0].scrollIntoView();
  }, []);
  return (
    <div className="dc-page-bg">
      <div className="dc-ctn">
        <IonRow className="mob-view casino-filter-row">
          <IonCol sizeXs="6" sizeSm="6">
            <IonSelect
              className="casino-filter"
              value={casinoGameCatTabValue}
              placeholder="Live Casino"
              interface="popover"
              onIonChange={(e) => setCasinoGameCatTabValue(e.detail.value)}
            >
              {filterList &&
                filterList.map((opt, idx) => (
                  <IonSelectOption key={'option-' + idx} value={opt.value}>
                    {opt.label}
                  </IonSelectOption>
                ))}
            </IonSelect>
          </IonCol>
          <IonCol sizeXs="6" sizeSm="6">
            <IonSelect
              className="casino-filter"
              value={filteredProvider}
              placeholder="Select One"
              interface="popover"
              onIonChange={(e) => setFilteredProvider(e.detail.value)}
            >
              <IonSelectOption key={'option--1'} value={''}>
                {'Select Provider'}
              </IonSelectOption>
              {providerList &&
                providerList.map((opt, idx) => (
                  <IonSelectOption key={'option-' + idx} value={opt}>
                    {opt}
                  </IonSelectOption>
                ))}
            </IonSelect>
          </IonCol>
        </IonRow>

        <IonRow>
          <IonCol sizeMd="1.8" sizeLg="1.8" className="web-view">
            <div className="compt-menu-section">
              <div className="sticky-col">
                <CompetitionsMenu loggedIn={true} />
              </div>
            </div>
          </IonCol>
          <IonCol sizeXs="12" sizeSm="12" sizeMd="8" sizeLg="8">
            <div className="casino-title-ctn web-view">
              <IonSelect
                className="casino-title"
                value={casinoGameCatTabValue}
                placeholder="Live Casino"
                interface="popover"
                onIonChange={(e) => setCasinoGameCatTabValue(e.detail.value)}
              >
                {filterList &&
                  filterList.map((opt, idx) => (
                    <IonSelectOption key={'option-' + idx} value={opt.value}>
                      {opt.label}
                    </IonSelectOption>
                  ))}
              </IonSelect>

              <IonSelect
                className="casino-title"
                value={filteredProvider}
                placeholder="Select One"
                interface="popover"
                onIonChange={(e) => setFilteredProvider(e.detail.value)}
              >
                <IonSelectOption key={'option--1'} value={''}>
                  {'Select Provider'}
                </IonSelectOption>
                {providerList &&
                  providerList.map((opt, idx) =>
                    opt && opt === 'Ezugi' ? null : (
                      <IonSelectOption key={'option-' + idx} value={opt}>
                        {opt}
                      </IonSelectOption>
                    )
                  )}
              </IonSelect>
              {/* </div> */}
            </div>
            <div className="title-card mob-view">
              {/* <span className="active-text">{slotGamesList?.length}</span> Games{' '} */}
              <div className="search-bar-component" ref={eventListRef}>
                <input
                  className="search-game-input"
                  placeholder="Search Games"
                  type="text"
                  value={searchQuery}
                  onChange={(e: any) => handleChange(e.target.value)}
                />
                {showDropDown ? (
                  <div className={'casino-list-drop-down'}>
                    {dropDownList.map((g) => {
                      return (
                        <div
                          className="casino-drop-down"
                          key={g.gameId}
                          onClick={(e) =>
                            handleGameClick(
                              g?.gameId,
                              g?.gameName,
                              g?.gameCode,
                              g?.subProviderName,
                              g?.providerName
                            )
                          }
                          onTouchStart={() => handleGameClick(
                            g?.gameId,
                            g?.gameName,
                            g?.gameCode,
                            g?.subProviderName,
                            g?.providerName
                          )}
                        >
                          {g?.gameName}
                        </div>
                      );
                    })}
                  </div>
                ) : null}
              </div>
            </div>
            <div className="card mt-5">
              <div className="carw">
                <div className="arrow arrow-right">
                  <div className="casino-name">
                    <span className="color-active">
                      {filteredProvider ? filteredProvider : 'Recommended'}
                    </span>{' '}
                    <span className="web-view">Games</span>{' '}
                  </div>
                </div>
              </div>
              {filteredProvider.toLowerCase() === 'supernowa' &&
              superNowaGame.length === 0 ? (
                <div className="no-data">coming soon</div>
              ) : null}

              <TabPanel value={casinoGameCatTabValue} index={0}>
                {allList && allList.length > 0 ? (
                  <>
                    <IonRow className="dc-games-ctn">
                      {allList.map((g, i) => (
                        <>
                          {filteredProvider &&
                          g.subProviderName?.toLowerCase() !==
                            filteredProvider.toLowerCase() ? null : (
                            <IonCol
                              sizeXs="4"
                              sizeSm="4"
                              sizeMd="3"
                              sizeLg="3"
                              key={g.gameName}
                            >
                              <div className="container1">
                                <img
                                  src={g.urlThumb ? g.urlThumb : ''}
                                  alt={g.gameName}
                                  className="dc-img"
                                />
                                <div className="overlay1">
                                  <div className="text1">
                                    <div
                                      className="custom-btn"
                                      onClick={() =>
                                        handleGameClick(
                                          g.gameId,
                                          g.gameName,
                                          g.gameCode,
                                          g.subProviderName,
                                          g.providerName
                                        )
                                      }
                                    >
                                      <img src={inplay} alt="inplay" />
                                      <div> </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </IonCol>
                          )}
                        </>
                      ))}
                    </IonRow>
                  </>
                ) : (
                  <div className="no-data">No games found</div>
                )}
              </TabPanel>

              <TabPanel value={casinoGameCatTabValue} index={3}>
                {blackjackList && blackjackList.length > 0 ? (
                  <>
                    <IonRow className="dc-games-ctn">
                      {blackjackList.map((g, i) => (
                        <>
                          {filteredProvider &&
                          g.subProviderName?.toLowerCase() !==
                            filteredProvider?.toLowerCase() ? null : (
                            <IonCol
                              sizeXs="4"
                              sizeSm="4"
                              sizeMd="3"
                              sizeLg="3"
                              key={g.gameName}
                            >
                              <div className="container1">
                                <img
                                  src={g.urlThumb ? g.urlThumb : ''}
                                  alt={g.gameName}
                                  className="dc-img"
                                />
                                <div className="overlay1">
                                  <div className="text1">
                                    <div
                                      className="custom-btn"
                                      onClick={() =>
                                        handleGameClick(
                                          g.gameId,
                                          g.gameName,
                                          g.gameCode,
                                          g.subProviderName,
                                          g.providerName
                                        )
                                      }
                                    >
                                      <img src={inplay} alt="inplay" />
                                      <div> </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </IonCol>
                          )}
                        </>
                      ))}
                    </IonRow>
                  </>
                ) : (
                  <div className="no-data">No games found</div>
                )}
              </TabPanel>

              <TabPanel value={casinoGameCatTabValue} index={2}>
                {baccaratList && baccaratList.length > 0 ? (
                  <>
                    {/* <h1>Baccarat</h1> */}
                    <IonRow className="dc-games-ctn">
                      {baccaratList.map((g, i) => (
                        <>
                          {filteredProvider &&
                          g.subProviderName?.toLowerCase() !==
                            filteredProvider?.toLowerCase() ? null : (
                            <IonCol
                              sizeXs="4"
                              sizeSm="4"
                              sizeMd="3"
                              sizeLg="3"
                              key={g.gameName}
                            >
                              <div className="container1">
                                <img
                                  src={g.urlThumb ? g.urlThumb : ''}
                                  alt={g.gameName}
                                  className="dc-img"
                                />
                                <div className="overlay1">
                                  <div className="text1">
                                    <div
                                      className="custom-btn"
                                      onClick={() =>
                                        handleGameClick(
                                          g.gameId,
                                          g.gameName,
                                          g.gameCode,
                                          g.subProviderName,
                                          g.providerName
                                        )
                                      }
                                    >
                                      <img src={inplay} alt="inplay" />
                                      <div> </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </IonCol>
                          )}
                        </>
                      ))}
                    </IonRow>
                  </>
                ) : (
                  <div className="no-data">No games found</div>
                )}
              </TabPanel>

              <TabPanel value={casinoGameCatTabValue} index={4}>
                {pokerList && pokerList.length > 0 ? (
                  <>
                    <IonRow className="dc-games-ctn">
                      {pokerList.map((g, i) => (
                        <>
                          {filteredProvider &&
                          g.subProviderName?.toLowerCase() !==
                            filteredProvider?.toLowerCase() ? null : (
                            <IonCol
                              sizeXs="4"
                              sizeSm="4"
                              sizeMd="3"
                              sizeLg="3"
                              key={g.gameName}
                            >
                              <div className="container1">
                                <img
                                  src={g.urlThumb ? g.urlThumb : ''}
                                  alt={g.gameName}
                                  className="dc-img"
                                />
                                <div className="overlay1">
                                  <div className="text1">
                                    <div
                                      className="custom-btn"
                                      onClick={() =>
                                        handleGameClick(
                                          g.gameId,
                                          g.gameName,
                                          g.gameCode,
                                          g.subProviderName,
                                          g.providerName
                                        )
                                      }
                                    >
                                      <img src={inplay} alt="inplay" />
                                      <div> </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </IonCol>
                          )}
                        </>
                      ))}
                    </IonRow>
                  </>
                ) : (
                  <div className="no-data">No games found</div>
                )}
              </TabPanel>

              <TabPanel value={casinoGameCatTabValue} index={1}>
                {rouletteList && rouletteList.length > 0 ? (
                  <>
                    <IonRow className="dc-games-ctn">
                      {rouletteList.map((g, i) => (
                        <>
                          {filteredProvider &&
                          g.subProviderName?.toLowerCase() !==
                            filteredProvider?.toLowerCase() ? null : (
                            <IonCol
                              sizeXs="4"
                              sizeSm="4"
                              sizeMd="3"
                              sizeLg="3"
                              key={g.gameName}
                            >
                              <div className="container1">
                                <img
                                  src={g.urlThumb ? g.urlThumb : ''}
                                  alt={g.gameName}
                                  className="dc-img"
                                />

                                <div className="overlay1">
                                  <div className="text1">
                                    <div
                                      className="custom-btn"
                                      onClick={() =>
                                        handleGameClick(
                                          g.gameId,
                                          g.gameName,
                                          g.gameCode,
                                          g.subProviderName,
                                          g.providerName
                                        )
                                      }
                                    >
                                      <img src={inplay} alt="inplay" />
                                      <div> </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </IonCol>
                          )}
                        </>
                      ))}
                    </IonRow>
                  </>
                ) : (
                  <div className="no-data">No games found</div>
                )}
              </TabPanel>

              <TabPanel value={casinoGameCatTabValue} index={5}>
                {evolutionList && evolutionList.length > 0 ? (
                  <>
                    {/* <h1>Other</h1> */}
                    <IonRow className="dc-games-ctn">
                      {evolutionList.map((g, i) => (
                        <>
                          {filteredProvider &&
                          g.subProviderName?.toLowerCase() !==
                            filteredProvider?.toLowerCase() ? null : (
                            <IonCol
                              sizeXs="4"
                              sizeSm="4"
                              sizeMd="3"
                              sizeLg="3"
                              key={g.gameName}
                            >
                              <div className="container1">
                                <img
                                  src={g.urlThumb ? g.urlThumb : ''}
                                  alt={g.gameName}
                                  className="dc-img"
                                />
                                <div className="overlay1">
                                  <div className="text1">
                                    <div
                                      className="custom-btn"
                                      onClick={() =>
                                        handleGameClick(
                                          g.gameId,
                                          g.gameName,
                                          g.gameCode,
                                          g.subProviderName,
                                          g.providerName
                                        )
                                      }
                                    >
                                      <img src={inplay} alt="inplay" />
                                      <div> </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </IonCol>
                          )}
                        </>
                      ))}
                    </IonRow>
                  </>
                ) : (
                  <div className="no-data">No games found</div>
                )}
              </TabPanel>

              <TabPanel value={casinoGameCatTabValue} index={6}>
                {pragmaticList && pragmaticList.length > 0 ? (
                  <>
                    <IonRow className="dc-games-ctn">
                      {pragmaticList.map((g, i) => (
                        <>
                          {filteredProvider &&
                          g.subProviderName?.toLowerCase() !==
                            filteredProvider?.toLowerCase() ? null : (
                            <IonCol
                              sizeXs="4"
                              sizeSm="4"
                              sizeMd="3"
                              sizeLg="3"
                              key={g.gameName}
                            >
                              <div className="container1">
                                <img
                                  src={g.urlThumb ? g.urlThumb : ''}
                                  alt={g.gameName}
                                  className="dc-img"
                                />
                                <div className="overlay1">
                                  <div className="text1">
                                    <div
                                      className="custom-btn"
                                      onClick={() =>
                                        handleGameClick(
                                          g.gameId,
                                          g.gameName,
                                          g.gameCode,
                                          g.subProviderName,
                                          g.providerName
                                        )
                                      }
                                    >
                                      <img src={inplay} alt="inplay" />
                                      <div> </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </IonCol>
                          )}
                        </>
                      ))}
                    </IonRow>
                  </>
                ) : (
                  <div className="no-data">No games found</div>
                )}
              </TabPanel>

              <TabPanel value={casinoGameCatTabValue} index={7}>
                {superspadeList && superspadeList.length > 0 ? (
                  <>
                    <IonRow className="dc-games-ctn">
                      {superspadeList.map((g, i) => (
                        <>
                          {filteredProvider &&
                          g.subProviderName?.toLowerCase() !==
                            filteredProvider?.toLowerCase() ? null : (
                            <IonCol
                              sizeXs="4"
                              sizeSm="4"
                              sizeMd="3"
                              sizeLg="3"
                              key={g.gameName}
                            >
                              <div className="container1">
                                <img
                                  src={g.urlThumb ? g.urlThumb : ''}
                                  alt={g.gameName}
                                  className="dc-img"
                                />
                                <div className="overlay1">
                                  <div className="text1">
                                    <div
                                      className="custom-btn"
                                      onClick={() =>
                                        handleGameClick(
                                          g.gameId,
                                          g.gameName,
                                          g.gameCode,
                                          g.subProviderName,
                                          g.providerName
                                        )
                                      }
                                    >
                                      <img src={inplay} alt="inplay" />
                                      <div> </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </IonCol>
                          )}
                        </>
                      ))}
                    </IonRow>
                  </>
                ) : (
                  <div className="no-data">No games found</div>
                )}
              </TabPanel>

              <TabPanel value={casinoGameCatTabValue} index={8}>
                {otherList && otherList.length > 0 ? (
                  <>
                    {/* <h1>Other</h1> */}
                    <IonRow className="dc-games-ctn">
                      {otherList.map((g, i) => (
                        <>
                          {filteredProvider &&
                          g.subProviderName?.toLowerCase() !==
                            filteredProvider?.toLowerCase() ? null : (
                            <IonCol
                              sizeXs="4"
                              sizeSm="4"
                              sizeMd="3"
                              sizeLg="3"
                              key={g.gameName}
                            >
                              <div className="container1">
                                <img
                                  src={g.urlThumb ? g.urlThumb : ''}
                                  alt={g.gameName}
                                  className="dc-img"
                                />
                                <div className="overlay1">
                                  <div className="text1">
                                    <div
                                      className="custom-btn"
                                      onClick={() =>
                                        handleGameClick(
                                          g.gameId,
                                          g.gameName,
                                          g.gameCode,
                                          g.subProviderName,
                                          g.providerName
                                        )
                                      }
                                    >
                                      <img src={inplay} alt="inplay" />
                                      <div> </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </IonCol>
                          )}
                        </>
                      ))}
                    </IonRow>
                  </>
                ) : (
                  <div className="no-data">No games found</div>
                )}
              </TabPanel>

              <TabPanel value={casinoGameCatTabValue} index={9}>
                {betGamesList && betGamesList.length > 0 ? (
                  <>
                    {/* <h1>Other</h1> */}
                    <IonRow className="dc-games-ctn">
                      {betGamesList.map((g, i) => (
                        <>
                          {filteredProvider &&
                          g.subProviderName?.toLowerCase() !==
                            filteredProvider.toLowerCase() ? null : (
                            <IonCol
                              sizeXs="4"
                              sizeSm="4"
                              sizeMd="3"
                              sizeLg="3"
                              key={g.gameName}
                            >
                              <div className="container1">
                                <img
                                  src={g.urlThumb ? g.urlThumb : ''}
                                  alt={g.gameName}
                                  className="dc-img"
                                />
                                <div className="overlay1">
                                  <div className="text1">
                                    <div
                                      className="custom-btn"
                                      onClick={() =>
                                        handleGameClick(
                                          g.gameId,
                                          g.gameName,
                                          g.gameCode,
                                          g.subProviderName,
                                          g.providerName
                                        )
                                      }
                                    >
                                      <img src={inplay} alt="inplay" />
                                      <div> </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </IonCol>
                          )}
                        </>
                      ))}
                    </IonRow>
                  </>
                ) : (
                  <div className="no-data">No games found</div>
                )}
              </TabPanel>

              <TabPanel value={casinoGameCatTabValue} index={10}>
                {virtualList && virtualList.length > 0 ? (
                  <>
                    {/* <h1>Other</h1> */}
                    <IonRow className="dc-games-ctn">
                      {virtualList.map((g, i) => (
                        <>
                          <IonCol
                            sizeXs="4"
                            sizeSm="4"
                            sizeMd="3"
                            sizeLg="3"
                            key={g.gameName}
                          >
                            <div className="container1">
                              <img
                                src={g.urlThumb ? g.urlThumb : ''}
                                alt={g.gameName}
                                className="dc-img"
                              />
                              <div className="overlay1">
                                <div className="text1">
                                  <div
                                    className="custom-btn"
                                    onClick={() =>
                                      handleGameClick(
                                        g.gameId,
                                        g.gameName,
                                        g.gameCode,
                                        g.subProviderName,
                                        g.providerName
                                      )
                                    }
                                  >
                                    <img src={inplay} alt="inplay" />
                                    <div> </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </IonCol>
                        </>
                      ))}
                    </IonRow>
                  </>
                ) : (
                  <div className="no-data">No games found</div>
                )}
              </TabPanel>

              <TabPanel value={casinoGameCatTabValue} index={10}>
                {aeSexy && aeSexy.length > 0 ? (
                  <>
                    {/* <h1>Other</h1> */}
                    <IonRow className="dc-games-ctn">
                      {aeSexy.map((g, i) => (
                        <>
                          <IonCol
                            sizeXs="4"
                            sizeSm="4"
                            sizeMd="3"
                            sizeLg="3"
                            key={g.gameName}
                          >
                            <div className="container1">
                              <img
                                src={g.urlThumb ? g.urlThumb : ''}
                                alt={g.gameName}
                                className="dc-img"
                              />
                              <div className="overlay1">
                                <div className="text1">
                                  <div
                                    className="custom-btn"
                                    onClick={() =>
                                      handleGameClick(
                                        g.gameId,
                                        g.gameName,
                                        g.gameCode,
                                        g.subProviderName,
                                        g.providerName
                                      )
                                    }
                                  >
                                    <img src={inplay} alt="inplay" />
                                    <div> </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </IonCol>
                        </>
                      ))}
                    </IonRow>
                  </>
                ) : (
                  <div className="no-data">No games found</div>
                )}
              </TabPanel>
            </div>
          </IonCol>

          <IonCol sizeMd="2" sizeLg="2" className="web-view">
            {/* <div className="casino-search">
              <Autocomplete
                freeSolo
                id="free-solo-2-demo"
                className="search-games-ctn web-view"
                disableClearable
                options={games}
                selectOnFocus={false}
                disabledItemsFocusable={false}
                getOptionLabel={(option) => option.gameName}
                onChange={(event, g) => {
                  handleGameClick(
                    Object(g).gameId,
                    Object(g).gameName,
                    Object(g).gameCode,
                    Object(g).subProviderName,
                    Object(g).providerName
                  );
                }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="Search Game"
                    margin="normal"
                    variant="outlined"
                    className="search-games-text"
                    InputProps={{ ...params.InputProps, type: 'search' }}
                  />
                )}
              />
            </div>
            <div className="compt-menu-section">
              <RightSideNav1 />
            </div> */}
            <div className="compt-menu-section">
              <div className="search-bar-component" ref={eventListRef}>
                <input
                  className="search-game-input"
                  placeholder="Search Games"
                  type="text"
                  value={searchQuery}
                  onChange={(e: any) => handleChange(e.target.value)}
                />
                {showDropDown ? (
                  <div className={'casino-list-drop-down'}>
                    {dropDownList.map((g) => {
                      return (
                        <div
                          className="casino-drop-down"
                          onClick={(e) =>
                            handleGameClick(
                              g?.gameId,
                              g?.gameName,
                              g?.gameCode,
                              g?.subProviderName,
                              g?.providerName
                            )
                          }
                        >
                          {g?.gameName}
                        </div>
                      );
                    })}
                  </div>
                ) : null}
              </div>
              <RightSideNav1 />
            </div>
          </IonCol>
        </IonRow>
      </div>

      <Dialog
        open={modalOpen}
        onClose={() => setModalOpen(false)}
        aria-labelledby="form-dialog-title"
        className="dialog-div1"
      >
        <div className="dialog-div-body">
          <div className="go-corner" onClick={() => setModalOpen(false)}>
            <div className="go-arrow">
              <ClearIcon />
            </div>
          </div>
          <div className="dialog-body">
            <div className="dialog-title">Notice</div>

            <p className="dialog-ex">You have to be logged in to play</p>
          </div>

          <div className="dialog-continue" onClick={() => setModalOpen(false)}>
            <div className="custom-btn btn">OK</div>
          </div>
        </div>
      </Dialog>

      <Dialog
        open={openDialog}
        onClose={() => setOpenDialog(false)}
        aria-labelledby="form-dialog-title"
        className="dialog-div"
      >
        <div className="dialog-div-body">
          <div className="go-corner" onClick={() => history.goBack()}>
            <div className="go-arrow">
              <ClearIcon />
            </div>
          </div>

          {getCurrencyTypeFromToken() === 0 ? (
            <div className="dialog-body">
              {/* 1 Live casino point is equal to 100 normal points
              <div className="dialog-ex">
                {' '}
                Ex: 100 casino points = 10000 normal points
              </div> */}
              <img src={casinobg} />

              <p className="dialog-ex">
                Maximum Bet limit is 5000 casino points
              </p>
            </div>
          ) : null}

          {getCurrencyTypeFromToken() === 1 ? (
            <>
              {' '}
              <div className="dialog-body">
                <img src={casinobg} />
                <div className="dialog-ex">
                  {' '}
                  Maximum Bet Limit For All Games is 5000
                </div>
              </div>
            </>
          ) : null}

          <div className="dialog-continue" onClick={() => setOpenDialog(false)}>
            <div className="custom-btn">Continue</div>
          </div>
        </div>
      </Dialog>

      <Dialog
        open={infoDialog}
        onClose={() => {
          setInfoDialog(false);
          setSelectedEvolutionGame(null);
        }}
        aria-labelledby="form-dialog-title"
        className="dialog-div"
      >
        <div className="dialog-div-body">
          <div className="dialog-title">Game Info</div>
          <div className="dialog-body">
            1 Casino Point is equal to 10 Normal Points.
            <div className="dialog-ex">
              {' '}
              Ex: 100 Casino Points = 1000 Points
            </div>
          </div>
          <div className="dialog-continue">
            <div
              className="custom-btn btn"
              onClick={() =>
                getGameUrl(
                  selectedEvolutionGame?.gameId,
                  selectedEvolutionGame?.gameName,
                  selectedEvolutionGame?.gameCode,
                  selectedEvolutionGame?.provider,
                  selectedEvolutionGame?.subProvider
                )
              }
            >
              Continue
            </div>

            <div
              className="custom-btn-close"
              onClick={() => {
                setInfoDialog(false);
                setSelectedEvolutionGame(null);
              }}
            >
              Close
            </div>
          </div>
        </div>
      </Dialog>
    </div>
  );
};

const mapStateToProps = (state: RootState) => {
  let status = 0;
  if (state.auth.loggedIn) {
    status = JSON.parse(
      window.atob(sessionStorage.getItem('jwt_token').split('.')[1])
    ).status;
  }

  return {
    loggedIn: state.auth.loggedIn,
    loggedInUserStatus: status,
    liveCasinoGames: state.indianCasino.liveCasinoGames,
    searchGame: state.indianCasino.searchGame,
  };
};

const mapDispatchToProps = (dispatch: Function) => {
  return {
    FatchLiveCasinoGames: (type: string) =>
      dispatch(FatchLiveCasinoGames(type)),
    setSearchGame: (data: string) => dispatch(setSearchGame(data)),
    handleSearchGame: () => dispatch(handleSearchGame()),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(DcPageNew);
